export const adminNavigationGroups = [
  { name: "Workspace", paths: ["/dashboard"] },
  {
    name: "People",
    paths: ["/users", "/admins", "/administrators", "/social-groups"],
  },
  {
    name: "Review",
    paths: [
      "/profile-reviews",
      "/itinerary-reviews",
      "/video-verifications",
      "/review-sessions",
      "/cyra-suggestions",
      "/support-requests",
      "/city-reports",
      "/urgent-notices",
      "/social-reviews",
      "/social-message-reviews",
      "/social-reports",
      "/email-changes",
      "/account-deletions",
      "/audit",
    ],
  },
  { name: "Content", paths: ["/schedules", "/destinations", "/experiences", "/partners"] },
  {
    name: "Legal and Help",
    paths: [
      "/legal/terms",
      "/legal/privacy",
      "/public-content/help",
      "/public-content/faq",
      "/public-content/standards",
    ],
  },
] as const;
